var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAudioWidget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#audio-widget_svg__clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.298.586a.532.532 0 00-.564.064L3.546 4.8h-2.48C.48 4.8 0 5.28 0 5.867v4.267C0 10.72.479 11.2 1.067 11.2h2.479l5.187 4.15a.539.539 0 00.565.065.535.535 0 00.302-.481V1.067a.535.535 0 00-.302-.481zM3.2 10.134H1.067V5.867H3.2v4.267zm5.333 3.69L4.267 10.41V5.59l4.266-3.413v11.646zM12.3 4.229a.533.533 0 10-.75.758A4.204 4.204 0 0112.8 8a4.204 4.204 0 01-1.25 3.014.532.532 0 10.75.757 5.255 5.255 0 001.566-3.77A5.26 5.26 0 0012.3 4.228z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.805 2.726a.534.534 0 00-.75.757A6.318 6.318 0 0114.933 8c0 1.711-.668 3.316-1.88 4.518a.534.534 0 00.751.757A7.376 7.376 0 0016 8c0-1.998-.78-3.87-2.195-5.274z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "audio-widget_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/audio-widget.18eb142bf92f4589ae799955970f59ff.svg";
export { SvgAudioWidget as ReactComponent };